import BaseAPI from "../api";
const path:string = 'nationality';


export class NationalityApi extends BaseAPI{
    static getAll():Promise<any>{
        return this.api.get(`${path}`)
    }
}